module.exports = __webpack_public_path__ + "static/media/_MG_0511.2be7bfde.JPG";